import useLogOut from '@src/hooks/useLogOut';
import { useUserIdentity, useVideoCreatorStore } from '@src/stores-v2';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import OrganizationAvatarTooltip from './OrganizationAvatarTooltip';
import OrganizationAvatarWithTooltip from './OrganizationAvatarWithTootlip';

type OrganizationSwitcherAvatarProps = {
  logoSize?: number;
  compact?: boolean;
};

function SingleOrganizationAvatar({
  logoSize = 34,
  compact = false,
}: OrganizationSwitcherAvatarProps) {
  const videoCreator = useVideoCreatorStore();
  const userIdentity = useUserIdentity();
  const { logOut } = useLogOut();

  const album = videoCreator.organization;
  const email = userIdentity.currentIdentity?.email;
  const username = userIdentity.currentEditor;

  const renderReactTooltip = useCallback(
    () => (
      <OrganizationAvatarTooltip
        onLogOut={logOut}
        email={email}
        compact={compact}
        album={album}
        username={username}
      />
    ),
    [email, logOut, compact, album, username],
  );

  const hoverLabel = compact
    ? [album?.title, username].filter(Boolean).join(' · ')
    : undefined;

  return (
    <OrganizationAvatarWithTooltip
      album={album}
      username={username}
      logoSize={logoSize}
      compact={compact}
      hoverLabel={hoverLabel}
      email={email}
      renderReactTooltip={renderReactTooltip}
    />
  );
}

export default observer(SingleOrganizationAvatar);
